import { Input } from '@nextui-org/react'
import Link from 'next/link'
import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import Layout from '../components/Layout'

const AboutPage = () => (
  <Layout title="Penusa | Contact">
    <div className="container-fluid" id="contact-page-header">
      <div className="background-img"></div>
    </div>
    <div className="container" id="contact-page">
      <div className="row">
        <div className='co-12'>
          <h1>Penusa is the supplier for all of your promotional&nbsp;needs</h1>
        </div>
        <div className='col-md'>
          <p>We are the leading promotional and executive gift supplier that offers excellent quality service through integrity and commitment. Established in 1993, Penusa has expanded into an international enterprise providing outstanding service to clients in North America, Europe, and Asia.</p>
          <p>Our mission is to deliver <strong>superior quality products at affordable prices</strong>. Penusa prides ourselves with <strong>exceptional efficiency, meticulous craftsmanship, and highly personalized service</strong>. </p>
        </div>
        <div className="col-md">
          <p className="contact-info">
            <span className="material-icons">phone</span>
            <a href='tel:1-877-736-8721'>1-877-736-8721</a>
          </p>
          <p className="contact-info">
            <span className="material-icons">mail</span>
            <a href='mailto:services@penusa.com'>services@penusa.com</a>
          </p>
          <p className="contact-info">
            <span className="material-icons">location_on</span>
            <a href='https://goo.gl/maps/xxtm3Bk87CxQL6DS6'>
              200 Cochrane Dr Unit 7, Markham,&nbsp;ON L3R&nbsp;8E8
            </a>
          </p>
          <Form />
        </div>
      </div>
      <div className="row">
      </div>
    </div>
  </Layout>
)

function Form() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [status, setStatus] = useState<"default" | "loading" | "error" | "success">("default");

  const submitForm = async (e: any) => {
    setStatus("loading");
    e.preventDefault();
    try {
      const resp = await fetch('/api/email', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          msg: comment,
          subject: `PENUSA message from ${name}`,
          customerEmail: email,
        })
      })
      if (resp.ok) {
        setStatus("success");
      } else {
        setStatus("error");
      }
    } catch (err: any) {
      console.error(err);
      setStatus("error");
    }
  }

  return (
    <form onSubmit={e => submitForm(e)} id="contact-form">
      {status === "error" && <Alert variant="danger">Something went wrong. Please try again later.</Alert>}
      {status === "success" && <Alert variant="success">Submitted!</Alert>}
      <h4>Send us a message!</h4>
      <div className="custom-input">
        <input type="text" name="name" id="name" required onChange={e => setName(e.target.value)} />
        <label htmlFor="name">Name</label>
      </div>
      <div className="custom-input">
        <input type="text" name="email" id="email" required onChange={e => setEmail(e.target.value)} />
        <label htmlFor="email">E-mail</label>
      </div>
      <div className="custom-input">
        <textarea name="comment" id="comment" required onChange={e => setComment(e.target.value)} />
        <label htmlFor="comment">Comment</label>
      </div>
      <button type="submit" name="submit" value="Send" className="submit orange">
        {status === "loading" ? "Loading..." : "Submit"}
      </button>
    </form>
  )
}

export default AboutPage
